import React, {useState} from "react";
import {useForm} from "react-hook-form";
import BrandFields from "./BrandFields";

export default function () {
  const {register, handleSubmit, reset, control, watch} = useForm();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const brandFields = <BrandFields {...{register, errors, control, watch, data}} />;

  return {
    setErrors,
    brandFields,
    handleSubmit,
    setData,
    reset,
  }
}